import React from 'react';
import { InputLabel } from '@material-ui/core';

const SelectLabel = ({ props, children }) => {
  return <InputLabel {...props}>{children}</InputLabel>;
};

export default SelectLabel;
